// Dot colorat pentru tipul de utilizare mașină.
// Spec: verde (personal), coral (inchiriat), galben (ridesharing). Default: gri.

const TONES = {
  personal: 'bg-ok',
  inchiriat: 'bg-coral',
  ridesharing: 'bg-warn',
  taxi: 'bg-teal-bright',
  altele: 'bg-muted',
};

const LABELS = {
  personal: 'Personal',
  inchiriat: 'Închiriat',
  ridesharing: 'Ridesharing',
  taxi: 'Taxi',
  altele: 'Altele',
};

export function UsageDot({ kind, label = true, className = '' }) {
  const tone = TONES[kind] || 'bg-muted';
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span className={`h-2 w-2 rounded-full ${tone}`} aria-hidden />
      {label && <span className="text-xs text-muted">{LABELS[kind] || kind}</span>}
    </span>
  );
}
